import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Dialog, DialogActions, Divider } from '@material-ui/core';
import ProcessingLoader from '../shared/ProcessingLoader';
import AppService from '../../services/AppService';

const CheckOutModal = ({
  selectedCover,
  isPopupOpen,
  setIsPopUpOpen,
  occasionId,
  fetchScannedList,
  setSelectedCover,
}) => {
  const [isLoading, setIsLoading] = useState('');

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await AppService.getCheckOutbyId(selectedCover?.id);
      toast.success('تم تسجيل الخروج');
      setTimeout(() => {
        fetchScannedList(occasionId);
      }, 200);
      setIsPopUpOpen(false);
      setIsLoading(false);
    } catch (e) {
      toast.error(e?.response?.data?.message ?? 'فشل في تسجيل الخروج ');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setSelectedCover('');
    };
  }, []);

  return (
    <div className="">
      <Dialog
        open={isPopupOpen}
        onClose={() => setIsPopUpOpen((prev) => !prev)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ProcessingLoader /> <span> جاري تسجيل خروج {selectedCover?.invitee?.name} ... </span>
          </div>
        ) : (
          <>
            <div
              style={{
                padding: 30,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              تأكيد تسجيل خروج {selectedCover?.invitee?.name}؟
            </div>
            <Divider />
          </>
        )}
        <DialogActions
          style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}
        >
          <Button
            variant="contained"
            type="submit"
            onClick={() => setIsPopUpOpen(false)}
            color="default"
          >
            الغاء
          </Button>
          <Button
            style={{ backgroundColor: '#006782', color: 'white', margin: 5 }}
            variant="contained"
            type="submit"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            تأكيد
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CheckOutModal;
